/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { ValidationType } from '../../enum/validation-type.enum';
import { ValidationMode } from '../../enum/validation-mode.enum';
import { ValidationError } from './validation-error';
import { ValidationWarning } from './validation-warning';

export class Validation {
  /**
   * Validation type
   */
  type: ValidationType = ValidationType.regexp;
  /**
   * Rule to apply
   */
  rule: string;
  /**
   * Message to show
   */
  message = '';
  /**
   * Mode d'affichage
   */
  mode: ValidationMode = ValidationMode.error;

  constructor(obj: {
    type: ValidationType;
    mode: ValidationMode;
    rule: string;
    message: string;
  }) {
    if (obj && typeof obj === 'object') {
      this.type = obj.type;
      this.mode = obj.mode;
      this.rule = obj.rule;
      this.message = obj.message;
    }
  }

  /**
   * Allow us to know if the value is accepted
   * @param value
   */
  validate(value: string): true | ValidationError | ValidationWarning {
    switch (this.type) {
      case ValidationType.regexp:
        return this.validateRegexp(value);
      default:
        console.warn('Validation type ' + this.type + ' is not handle yet');
        return new ValidationWarning(
          'Validation type ' + this.type + ' is not handle yet',
        );
    }
  }

  private validateRegexp(
    value: string,
  ): true | ValidationError | ValidationWarning {
    if (value === undefined || value === null) {
      value = '';
    }
    const regexp = new RegExp(this.rule);
    if (value.match(regexp) !== null) {
      return true;
    }
    return this.getMessage();
  }

  /**
   * Return a validation error
   * Todo :: return ValidationError | ValidationWarning ?
   */
  getMessage(): ValidationError | ValidationWarning {
    if (this.mode === ValidationMode.error) {
      return new ValidationError(this.message);
    }
    return new ValidationWarning(this.message);
  }
}
